/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from "../util/Permission";
import {BillingCurrency} from './OrganisationType';

export const BILL_TYPE_RECURRING = "recurring";
export const BILL_TYPE_ONCE = "once";

export const BillType = {
    [BILL_TYPE_RECURRING]: {
        name: "Recurring",
    },
    [BILL_TYPE_ONCE]: {
        name: "Once",
    }
};


export default declareEntity({
    entity: "billingItems",
    graphQL: "BillingItem",
    name: "Billing Item",
    dynamoPrefix: 'org',
    storageType: 'schema',
    parentRelation: "billingItems",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL,
    ],
	defaultOrder: [['period', 'DESC']],
    fields: (types) => { return {
        id: {
            name: "Billing Item ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            required: true,
            filterable: true,
            hiddenCreate: true,
        },
        organisationName: {
            name: "Organisation Name",
            type: "string",
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
        },
        scenario: {
            name: "Scenario",
            to: () => types['scenarios'],
            type: "relation",
        },
        scenarioDef: {
            name: "Scenario Definition",
            to: () => types['scenarioDefs'],
            type: "relation",
        },
        period: {
            name: "Period",
            type: "string",
        },
        periodStart: {
            name: "Period Start",
            type: "date",
        },
        periodEnd: {
            name: "Period End",
            type: "date",
        },
        billType: {
            name: "Bill Type",
            type: "enum",
            defaultValue: BILL_TYPE_RECURRING,
            values: BillType,
        },
        billedValue: {
            name: "Billed Value",
            type: "int",
            required: true,
            defaultValue: 0,
        },
        billedValueError: {
            name: "Billed Value Error",
            type: "boolean",
        },
        billedText: {
            name: "Billed Text",
            type: "string",
            defaultValue: '',
        },
        billedNote: {
            name: "Billed Note",
            type: "string",
            defaultValue: '',
        },
        billedPrice: {
            name: "Billed Price",
            type: "number",
            required: true,
            defaultValue: 0,
        },
        currency: {
            name: "Currency",
            type: "enum",
            defaultValue: "CZK",
            values: BillingCurrency,
        },
        isBilled: {
            name: "Is Billed?",
            type: "boolean",
            defaultValue: false,
        },
        shouldBilled: {
            name: "Should be Billed?",
            type: "boolean",
            defaultValue: false,
        },
        productCode: {
            name: "Product Code",
            type: "string",
        },
        accountingCode: {
            name: "Accounting Code",
            type: "string",
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        flow: {
            name: "Flow",
            to: () => types['flows'],
            type: "relation",
            parent: true,
            filterable: true,
            hiddenCreate: true,
        },
        invoiceNo: {
            name: "Invoice No",
            type: "string",
        },
        invoiceDate: {
            name: "Invoice Date",
            type: "date",
        },
        flowName: {
            name: "Flow Name",
            type: "string",
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
        },
        extraInfo: {
            name: "Extra Info",
            type: "string",
        },
        channel: {
            name: "Channel",
            to: () => types['channels'],
            type: "relation",
        },
        channelName: {
            name: "Channel Name",
            type: "string",
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
